/* eslint sort-imports: "error" */
/* eslint sort-keys: "error" */

import acceptTenant from './acceptTenant';
import activateUser from './activateUser';
import addFavoriteListing from './addFavoriteListing';
import addListingExclusions from './addListingExclusions';
import addPaymentMethod from './addPaymentMethod';
import addPayoutMethod from './addPayoutMethod';
import addPoiDraft from './addPoiDraft';
import addSavedSearch from './addSavedSearch';
import addYoutubeVideo from './addYoutubeVideo';
import cancelConversation from './cancelConversation';
import changeConversationDate from './changeConversationDate';
import changeListingVideoOrder from './changeListingVideoOrder';
import chargeTenant from './chargeTenant';
import confirmListingPhotoUpload from './confirmListingPhotoUpload';
import confirmPayoutMethod from './confirmPayoutMethod';
import confirmUser from './confirmUser';
import confirmUserDocumentUpload from './confirmUserDocumentUpload';
import createBookingRequest from './createBookingRequest';
import createBookingRequestSCA from './createBookingRequestSCA';
import createConversation from './createConversation';
import createListing from './createListing';
import createMakeCall from './createMakeCall';
import createPayIn from './payments/createPayIn';
import createPayment from './createPayment';
import createPaymentMethod from './payments/createPaymentMethod';
import createPaymentSCA from './createPaymentSCA';
import createProspectiveLead from './createProspectiveLead';
import createSettlement from './payments/createSettlement';
import declineConversation from './declineConversation';
import deleteAttachment from './deleteAttachment';
import deleteConversationAttachment from './deleteConversationAttachment';
import deleteKycDocument from './deleteKycDocument';
import deleteListing from './deleteListing';
import deleteListingExclusions from './deleteListingExclusions';
import deleteListingPhoto from './deleteListingPhoto';
import deleteListingVideo from './deleteListingVideo';
import deleteListingVideos from './deleteListingVideos';
import deletePaymentMethod from './deletePaymentMethod';
import deleteUser from './deleteUser';
import deleteUserDocument from './deleteUserDocument';
import duplicateListing from './duplicateListing';
import editUserDocument from './editUserDocument';
import facebookLogin from './facebookLogin';
import generateListingClick from './generateListingClick';
import getCities from './getCities';
import getCitiesNearby from './getCitiesNearby';
import getConversation from './getConversation';
import getConversationByToken from './getConversationByToken';
import getConversationCounters from './getConversationCounters';
import getConversationMessages from './getConversationMessages';
import getConversationPayoutInfo from './getConversationPayoutInfo';
import getConversations from './getConversations';
import getCurrencyEuroRates from './getCurrencyEuroRates';
import getEngagements from './getEngagements';
import getFavoriteListings from './getFavoriteListings';
import getFeaturedCities from './getFeaturedCities';
import getFullUrl from './getFullUrl';
import getGlobalCounters from './getGlobalCounters';
import getInvoices from './getInvoices';
import getKycDocuments from './getKycDocuments';
import getLastMessageInConversation from './getLastMessageInConversation';
import getListingBookablePeriods from './getListingBookablePeriods';
import getListingById from './getListingById';
import getListingCosts from './getListingCosts';
import getListingExclusions from './getListingExclusions';
import getListingIcsCalendarLink from './getListingIcsCalendarLink';
import getListingPhotos from './getListingPhotos';
import getListingVideos from './getListingVideos';
import getListings from './getListings';
import getListingsSummary from './getListingsSummary';
import getPayIn from './payments/getPayIn';
import getPaymentMethod from './payments/getPaymentMethod';
import getPaymentMethodTypes from './payments/getPaymentMethodTypes';
import getPaymentMethods from './getPaymentMethods';
import getPaymentMethodsParams from './getPaymentMethodsParams';
import getPaymentParameters from './getPaymentParameters';
import getPayoutMethod from './getPayoutMethod';
import getPayoutMethods from './getPayoutMethods';
import getPoiCommercial from './getPoiCommercial';
import getPois from './getPois';
import getRealtimeToken from './getRealtimeToken';
import getRentalConditionsByConversationId from './getRentalConditionsByConversationId';
import getRentalConditionsById from './getRentalConditionsById';
import getRentalConditionsEstimate from './getRentalConditionsEstimate';
import getSavedSearches from './getSavedSearches';
import getSettlement from './payments/getSettlement';
import getSitemaps from './getSitemaps';
import getUniversities from './getUniversities';
import getUser from './getUser';
import getUserDocumentViewUrl from './getUserDocumentViewUrl';
import getUserDocuments from './getUserDocuments';
import getUserInformation from './getUserInformation';
import getUserKYCs from './getUserKycs';
import getUserPaymentMethods from './payments/getUserPaymentMethods';
import getUserQualification from './getUserQualification';
import getUserSubscriptions from './getUserSubscriptions';
import getUsers from './getUsers';
import googleLogin from './googleLogin';
import googleOneTapLogin from './googleOneTapLogin';
import impersonateUser from './impersonateUser';
import initSCAPaymentMethod from './initSCAPaymentMethod';
import linkDocumentToConversation from './linkDocumentToConversation';
import linkKycDocument from './linkKycDocument';
import login from './login';
import logout from './logout';
import makeSpecialOffer from './makeSpecialOffer';
import markConversationAsRead from './markConversationAsRead';
import markListingPhotoAs360 from './markListingPhotoAs360';
import postUserDocumentRequest from './postUserDocumentRequest';
import postUserKYC from './postUserKyc';
import publishListing from './publishListing';
import putUserKYC from './putUserKyc';
import recoverAccount from './recoverAccount';
import register from './register';
import registerListingClick from './registerListingClick';
import removeFavoriteListing from './removeFavoriteListing';
import removePayoutMethod from './removePayoutMethod';
import removeSavedSearch from './removeSavedSearch';
import replacesListingExclusions from './replacesListingExclusions';
import reportUser from './reportUser';
import requestActivationEmail from './requestActivationEmail';
import requestCode from './requestCode';
import requestListingPhotoUpload from './requestListingPhotoUpload';
import resetPassword from './resetPassword';
import saveSearch from './saveSearch';
import searchCity from './searchCity';
import sendMessage from './sendMessage';
import sendTalkPageFile from './sendTalkPageFile';
import setPayoutMethodAsDefault from './setPayoutMethodAsDefault';
import surveyUnpublishListing from './surveyUnpublishListing';
import toggleArchiveConversation from './toggleArchiveConversation';
import toggleFavoriteConversation from './toggleFavoriteConversation';
import translateListingDescription from './translateListingDescription';
import unpublishListing from './unpublishListing';
import updateKycStatus from './updateKycStatus';
import updateListing from './updateListing';
import updateListingPhoto from './updateListingPhoto';
import updateListingPhotosOrder from './updateListingPhotosOrder';
import updatePayoutMethod from './updatePayoutMethod';
import updateUser from './updateUser';
import updateUserSubscriptions from './updateUserSubscriptions';
import uploadAvatar from './uploadAvatar';
import uploadAvatarByUrl from './uploadAvatarByUrl';
import validatePhone from './validatePhone';
import verifyCode from './verifyCode';
import verifyManually from './verifyManually';

interface FetchClient {
  fetch: (url: string, options: RequestInit) => Promise<Response>;
}

export default (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    acceptTenant: acceptTenant(makeCall),
    activateUser: activateUser(makeCall),
    addFavoriteListing: addFavoriteListing(makeCall),
    addListingExclusions: addListingExclusions(makeCall),
    addPaymentMethod: addPaymentMethod(makeCall),
    addPayoutMethod: addPayoutMethod(makeCall),
    addPoiDraft: addPoiDraft(makeCall),
    addSavedSearch: addSavedSearch(makeCall),
    addYoutubeVideo: addYoutubeVideo(makeCall),
    cancelConversation: cancelConversation(makeCall),
    changeConversationDate: changeConversationDate(makeCall),
    changeListingVideoOrder: changeListingVideoOrder(makeCall),
    chargeTenant: chargeTenant(makeCall),
    confirmListingPhotoUpload: confirmListingPhotoUpload(makeCall),
    confirmPayoutMethod: confirmPayoutMethod(makeCall),
    confirmUser: confirmUser(makeCall),
    confirmUserDocumentUpload: confirmUserDocumentUpload(makeCall),
    createBookingRequest: createBookingRequest(makeCall),
    createBookingRequestSCA: createBookingRequestSCA(makeCall),
    createConversation: createConversation(makeCall),
    createListing: createListing(makeCall),
    createPayIn: createPayIn(makeCall),
    createPayment: createPayment(makeCall),
    createPaymentMethod: createPaymentMethod(makeCall),
    createPaymentSCA: createPaymentSCA(makeCall),
    createProspectiveLead: createProspectiveLead(makeCall),
    createSettlement: createSettlement(makeCall),
    declineConversation: declineConversation(makeCall),
    /** @deprecated use `deleteConversationAttachment` instead */
    deleteAttachment: deleteAttachment(makeCall),
    deleteConversationAttachment: deleteConversationAttachment(makeCall),
    deleteKycDocument: deleteKycDocument(makeCall),
    deleteListing: deleteListing(makeCall),
    deleteListingExclusions: deleteListingExclusions(makeCall),
    deleteListingPhoto: deleteListingPhoto(makeCall),
    deleteListingVideo: deleteListingVideo(makeCall),
    deleteListingVideos: deleteListingVideos(makeCall),
    deletePaymentMethod: deletePaymentMethod(makeCall),
    deleteUser: deleteUser(makeCall),
    deleteUserDocument: deleteUserDocument(makeCall),
    duplicateListing: duplicateListing(makeCall),
    editUserDocument: editUserDocument(makeCall),
    facebookLogin: facebookLogin(makeCall),
    generateListingClick: generateListingClick(makeCall),
    getCities: getCities(makeCall),
    getCitiesNearby: getCitiesNearby(makeCall),
    getConversation: getConversation(makeCall),
    getConversationByToken: getConversationByToken(makeCall),
    getConversationCounters: getConversationCounters(makeCall),
    getConversationMessages: getConversationMessages(makeCall),
    getConversationPayoutInfo: getConversationPayoutInfo(makeCall),
    getConversations: getConversations(makeCall),
    getCurrencyEuroRates: getCurrencyEuroRates(makeCall),
    getEngagements: getEngagements(makeCall),
    getFavoriteListings: getFavoriteListings(makeCall),
    getFeaturedCities: getFeaturedCities(makeCall),
    getFullUrl: getFullUrl(makeCall),
    getGlobalCounters: getGlobalCounters(makeCall),
    getInvoices: getInvoices(makeCall),
    getKycDocuments: getKycDocuments(makeCall),
    getLastMessageInConversation: getLastMessageInConversation(makeCall),
    getListingBookablePeriods: getListingBookablePeriods(makeCall),
    getListingById: getListingById(makeCall),
    getListingCosts: getListingCosts(makeCall),
    getListingExclusions: getListingExclusions(makeCall),
    getListingIcsCalendarLink: getListingIcsCalendarLink(makeCall),
    getListingPhotos: getListingPhotos(makeCall),
    getListingVideos: getListingVideos(makeCall),
    getListings: getListings(makeCall),
    getListingsSummary: getListingsSummary(makeCall),
    getPayIn: getPayIn(makeCall),
    getPaymentMethod: getPaymentMethod(makeCall),
    getPaymentMethodTypes: getPaymentMethodTypes(makeCall),
    getPaymentMethods: getPaymentMethods(makeCall),
    getPaymentMethodsParams: getPaymentMethodsParams(makeCall),
    getPaymentParameters: getPaymentParameters(makeCall),
    getPayoutMethod: getPayoutMethod(makeCall),
    getPayoutMethods: getPayoutMethods(makeCall),
    getPoiCommercial: getPoiCommercial(makeCall),
    getPois: getPois(makeCall),
    getRealtimeToken: getRealtimeToken(makeCall),
    getRentalConditionsByConversationId: getRentalConditionsByConversationId(
      makeCall,
    ),
    getRentalConditionsById: getRentalConditionsById(makeCall),
    getRentalConditionsEstimate: getRentalConditionsEstimate(makeCall),
    getSavedSearches: getSavedSearches(makeCall),
    getSettlement: getSettlement(makeCall),
    getSitemaps: getSitemaps(makeCall),
    getUniversities: getUniversities(makeCall),
    getUser: getUser(makeCall),
    getUserDocumentViewUrl: getUserDocumentViewUrl(makeCall),
    getUserDocuments: getUserDocuments(makeCall),
    getUserInformation: getUserInformation(makeCall),
    getUserKYCs: getUserKYCs(makeCall),
    getUserPaymentMethods: getUserPaymentMethods(makeCall),
    getUserQualification: getUserQualification(makeCall),
    getUserSubscriptions: getUserSubscriptions(makeCall),
    getUsers: getUsers(makeCall),
    googleLogin: googleLogin(makeCall),
    googleOneTapLogin: googleOneTapLogin(makeCall),
    impersonateUser: impersonateUser(makeCall),
    initSCAPaymentMethod: initSCAPaymentMethod(makeCall),
    linkDocumentToConversation: linkDocumentToConversation(makeCall),
    linkKycDocument: linkKycDocument(makeCall),
    login: login(makeCall),
    logout: logout(makeCall),
    makeSpecialOffer: makeSpecialOffer(makeCall),
    markConversationAsRead: markConversationAsRead(makeCall),
    markListingPhotoAs360: markListingPhotoAs360(makeCall),
    postUserDocumentRequest: postUserDocumentRequest(makeCall),
    postUserKYC: postUserKYC(makeCall),
    publishListing: publishListing(makeCall),
    putUserKYC: putUserKYC(makeCall),
    recoverAccount: recoverAccount(makeCall),
    register: register(makeCall),
    registerListingClick: registerListingClick(makeCall),
    removeFavoriteListing: removeFavoriteListing(makeCall),
    removePayoutMethod: removePayoutMethod(makeCall),
    removeSavedSearch: removeSavedSearch(makeCall),
    replacesListingExclusions: replacesListingExclusions(makeCall),
    reportUser: reportUser(makeCall),
    requestActivationEmail: requestActivationEmail(makeCall),
    requestCode: requestCode(makeCall),
    requestListingPhotoUpload: requestListingPhotoUpload(makeCall),
    resetPassword: resetPassword(makeCall),
    saveSearch: saveSearch(makeCall),
    searchCity: searchCity(makeCall),
    sendMessage: sendMessage(makeCall),
    sendTalkPageFile: sendTalkPageFile(makeCall),
    setPayoutMethodAsDefault: setPayoutMethodAsDefault(makeCall),
    surveyUnpublishListing: surveyUnpublishListing(makeCall),
    toggleArchiveConversation: toggleArchiveConversation(makeCall),
    toggleFavoriteConversation: toggleFavoriteConversation(makeCall),
    translateListingDescription: translateListingDescription(makeCall),
    unpublishListing: unpublishListing(makeCall),
    updateKycStatus: updateKycStatus(makeCall),
    updateListing: updateListing(makeCall),
    updateListingPhoto: updateListingPhoto(makeCall),
    updateListingPhotosOrder: updateListingPhotosOrder(makeCall),
    updatePayoutMethod: updatePayoutMethod(makeCall),
    updateUser: updateUser(makeCall),
    updateUserSubscriptions: updateUserSubscriptions(makeCall),
    uploadAvatar: uploadAvatar(makeCall),
    uploadAvatarByUrl: uploadAvatarByUrl(makeCall),
    validatePhone: validatePhone(makeCall),
    verifyCode: verifyCode(makeCall),
    verifyManually: verifyManually(makeCall),
  };
};
